import { Constants } from './../constants';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AuthenticatedResult } from 'angular-auth-oidc-client';
import { AuthService } from './Services/auth.service';
import { LanguageService } from './Services/language.service';
import { StorageService } from './Services/storage.service';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { LogoutModalComponent } from './components/modals/logout-modal/logout-modal.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  @ViewChild(LogoutModalComponent) private logoutModal: LogoutModalComponent;

  constructor(
    private authService: AuthService,
    private langService: LanguageService,
    private storage: StorageService,
    private idle: Idle,
    private router: Router
  ) { }

  ngOnInit() {
    this.setIdleSettings();
    this.authIdentity();
    window.addEventListener('storage', async (event) => {
      if (event.key === Constants.logoutState && event.newValue === 'true') {
        console.log('Logout state changed to true at: ', new Date());
        this.idle.stop();
        await this.router.navigate([Constants.loginPage]);
      }
    });
  }

  setIdleSettings() {
    this.idle.setIdle(Constants.idleLogOutTime);
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
    this.idle.onIdleStart.subscribe(async () => {
      if (this.storage.getLogoutState()) {
        this.idle.stop();
        await this.router.navigate([Constants.loginPage]);
      } else {
        console.log(`Idle start at: ${new Date()}`);
        this.logoutModal.open();
      }
    });
  }

  authIdentity() {
    this.authService.checkAuth().subscribe(() => {
    });

    this.authService.isLoggedIn().subscribe(async (res: AuthenticatedResult) => {
      const langFromStorage = this.storage.getLanguage();
      if (res.isAuthenticated) {
        this.storage.clearLogoutState();
        const user = await this.authService.getUserProfile();
        const lang = user?.locale ? user.locale : langFromStorage;
        this.langService.setLanguage(lang);
        if (lang !== langFromStorage) {
          this.storage.setLanguage(lang);
        }
        if (!this.idle.isRunning()) {
          this.idle.watch();
        }
      } else {
        this.langService.setLanguage(langFromStorage);
        this.idle.stop();
      }
    });
  }

  reset() {
    this.idle.watch();
  }

  ngOnDestroy() {
    this.idle.ngOnDestroy();
  }
}
